import { queryServiceByFormId } from './api/query-service-by-form-id';
import { isBookingsInstalled as isBookingsInstalledApi } from './api/is-booking-installed';
export const loadInitialAppointmentData = async (httpClient, errorHandler, wixCodeApi, formId, isEditor) => {
  if (isEditor) {
    return {};
  }
  const [service, isBookingsInstalled] = await Promise.all([queryServiceByFormId({
    httpClient,
    errorHandler,
    formId
  }), isBookingsInstalledApi({
    wixCodeApi
  })]);
  return {
    isBookingsInstalled,
    service
  };
};
//# sourceMappingURL=load-initial-appointment-data.js.map